import * as React from 'react';
import getDropState from '../selectors/getDropState';
import strings from 'owa-strings/owa-tasks-strings';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { getDraggedItemType } from 'owa-module-dnd-store';
import { observer } from 'mobx-react';

const styles = require('./ListOrDropHint.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class ListOrDropHint extends React.Component<{}, {}> {
    render() {
        if (!this.shouldShowDropHint()) {
            return this.props.children;
        }

        const dropViewState = getDropState();
        const dropHintAreaClassNames = classNames(styles.dropHintAreaInner, {
            isDraggingItemsIntoPanel: dropViewState.isDragOver,
        });

        return (
            <div className={styles.dropHintArea}>
                <span className={dropHintAreaClassNames}>
                    <span className={styles.dropHintIcon} />
                    <span className={styles.dropHintLabel}>{strings.addAsTask}</span>
                </span>
            </div>
        );
    }

    private shouldShowDropHint = (): boolean => {
        /**
         * getDraggedItemType() will tell us the item being dragged across the hosted module,
         * e.g. email in mail module.
         * Once the dragged email crosses out of the mail module bonudary, onDragLeave of the mail module
         * sets draggedItemType to null.
         * However, now, it enters the task pane. So our dropState will have the itemType of the item being dragged.
         */
        const draggedItemType = getDraggedItemType();
        const dropState = getDropState();

        return (
            this.shouldShowDropHintForItemType(draggedItemType) ||
            this.shouldShowDropHintForItemType(dropState.draggableItemType)
        );
    };

    private shouldShowDropHintForItemType = (draggedItemType: string): boolean => {
        return draggedItemType === DraggableItemTypes.MailListRow;
    };
}
